import { render, staticRenderFns } from "./CandidateJobPost.vue?vue&type=template&id=c07054ec"
import script from "./CandidateJobPost.vue?vue&type=script&lang=js"
export * from "./CandidateJobPost.vue?vue&type=script&lang=js"
import style0 from "./CandidateJobPost.vue?vue&type=style&index=0&id=c07054ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports